export default __webpack_public_path__ + "static/Entenda0055-58ac0e0054ecdbebde7e03eab63ea51b.jpg";